import React, { useEffect, useState } from 'react';
const NAMES = ['María', 'Laura', 'Carolina', 'Alejandra', 'Gabriela', 'Luciana', 'Valeria', 'Daniela', 'Marcela', 'Patricia', 'Silvia', 'Andrea', 'Claudia', 'Romina', 'Verónica', 'Natalia', 'Florencia', 'Soledad', 'Cecilia', 'Mariana'];
const CITIES = ['Buenos Aires', 'Madrid', 'Bogotá', 'Santiago', 'Lima', 'Ciudad de México', 'Montevideo', 'Quito', 'Barcelona', 'Valencia', 'Medellín', 'Guadalajara', 'Monterrey', 'San José', 'Ciudad de Panamá', 'Asunción', 'Caracas', 'La Paz', 'San Salvador', 'San Juan'];
const PRODUCTS = [{
  name: 'MegaPack + Adaptaciones',
  emoji: '🏆'
}, {
  name: 'MegaPack Italiano',
  emoji: '🇮🇹'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-318">
      <div className="bg-[#000d08] border border-[#00C853]/40 rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-319">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-320">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-321">
          <div className="w-2 h-2 bg-[#00C853] rounded-full animate-pulse" data-id="element-322" />
          <span className="text-[#00C853] text-xs font-bold uppercase tracking-wider" data-id="element-323">
            Compra verificada
          </span>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-324">
          <span className="font-bold" data-id="element-325">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-gray-300 text-sm mb-2" data-id="element-326">
          compró{' '}
          <span className="text-[#00C853] font-bold" data-id="element-327">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-gray-500 text-xs" data-id="element-328">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}